import { twMerge } from '@panwds/tailwindcss';
import React, { createContext } from 'react';
import { ADVANCED_VERTICAL_STEPPER_TYPE } from '../types.js';
import { findMaxStatusFillIndex } from './advanced_vertical_stepper.logic.js';
export const AdvancedVerticalStepperContext = createContext({
    items: [],
    stepperType: ADVANCED_VERTICAL_STEPPER_TYPE.CONSECUTIVE,
    maxStatusFilledIndex: undefined
});
export const AdvancedVerticalStepper = (props) => {
    const { dataTestId, dataMetrics, className, children, items = [], stepperType = ADVANCED_VERTICAL_STEPPER_TYPE.CONSECUTIVE } = props;
    const maxStatusFilledIndex = findMaxStatusFillIndex(items);
    return (React.createElement(AdvancedVerticalStepperContext.Provider, { value: {
            items,
            stepperType,
            maxStatusFilledIndex: maxStatusFilledIndex >= 0 ? maxStatusFilledIndex : undefined
        } },
        React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId, className: twMerge('twds-flex twds-flex-col', className) }, children)));
};
//# sourceMappingURL=advanced_vertical_stepper.js.map